import { useEffect } from 'react'
import { X } from 'lucide-react'
import { useAppDispatch, useAppSelector } from '@/lib/hooks'
import { setSidebarOpen } from '@/features/ui/uiSlice'
import Sidebar from './Sidebar'

export default function MobileDrawer() {
  const dispatch = useAppDispatch()
  const { sidebarOpen } = useAppSelector((state) => state.ui)

  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [sidebarOpen])

  if (!sidebarOpen) return null

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
        onClick={() => dispatch(setSidebarOpen(false))}
      />

      {/* Drawer */}
      <aside className="fixed inset-y-0 left-0 z-50 w-64 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 lg:hidden transform transition-transform ease-in-out duration-300">
        {/* Close button */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
                  <span className="text-lg font-semibold text-gray-900 dark:text-white">
          feedbeq
        </span>
          <button
            onClick={() => dispatch(setSidebarOpen(false))}
            className="p-1 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Sidebar content */}
        <div className="h-full">
          <Sidebar collapsed={false} />
        </div>
      </aside>
    </>
  )
} 